var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShirt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.707 7.79301L23.7 7.78601L19.8 4.03501C18.7765 3.04764 17.4091 2.49715 15.987 2.50001C15.887 2.52801 15.555 2.42901 15.487 2.80001C15.2511 4.56938 13.7831 5.91656 12 6.00001C10.2165 5.91703 8.74799 4.56974 8.512 2.80001C8.445 2.43001 8.112 2.52801 8.012 2.50001C6.59025 2.49741 5.22322 3.04788 4.2 4.03501L0.293 7.79301C-0.0973819 8.18351 -0.0973819 8.81651 0.293 9.20701L2.617 11.531C2.97529 11.8962 3.55295 11.9279 3.949 11.604L5.194 10.641C5.3455 10.5238 5.55069 10.5034 5.72229 10.5885C5.8939 10.6737 6.00176 10.8494 6 11.041V20.5C6 21.0523 6.44772 21.5 7 21.5H17C17.5523 21.5 18 21.0523 18 20.5V11.037C17.9982 10.8454 18.1061 10.6697 18.2777 10.5845C18.4493 10.4994 18.6545 10.5198 18.806 10.637L20.037 11.588C20.4341 11.9184 21.0174 11.8919 21.383 11.527L23.707 9.20301C24.0947 8.81297 24.0947 8.18305 23.707 7.79301Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt);
export default __webpack_public_path__ + "static/media/shirt.66124c6d.svg";
export { ForwardRef as ReactComponent };